import { useContext } from 'react';
import { videoPlayerContext } from '../contexts/VideoPlayer';

export const useVideoPlayer = () => {
  const {
    changePlaybackRate,
    changeVolume,
    currentTime,
    duration,
    isMuted,
    isPaused,
    isPlaying,
    mute,
    pause,
    play,
    playbackRate,
    seek,
    skip,
    unmute,
    volume,
    setVideoPlayerRef,
    cropping,
    setCropping,
    maskedDuration,
    fullscreen,
    toggleFullscreen,
    download,
    isEditable,
    isEditing,
    setIsEditable,
    setIsEditing,
    markers,
    setCropCallback,
    changeCropping,
    setContainerRef,
    isScrollingEnabled,
    changeScrollEnabled,
    togglePlay,
    ready,
    customEditingMessage,
    setCustomEditingMessage,
    notifyOn,
    setNotifyOn,
    blockActions,
    setBlockActions,
    showReactions,
    setShowReactions,
    useReaction,
    addReaction,
    setReactions,
    reactions,
    allowReactions,
    setAllowReactions,
  } = useContext(videoPlayerContext);

  return {
    ready,
    changePlaybackRate,
    setContainerRef,
    download,
    changeVolume,
    currentTime,
    duration,
    isMuted,
    isPaused,
    isPlaying,
    mute,
    pause,
    play,
    changeCropping,
    playbackRate,
    isScrollingEnabled,
    changeScrollEnabled,
    seek,
    skip,
    unmute,
    volume,
    setVideoPlayerRef,
    cropping,
    setCropping,
    maskedDuration,
    fullscreen,
    toggleFullscreen,
    isEditable,
    setIsEditable,
    isEditing,
    setIsEditing,
    markers,
    setCropCallback,
    togglePlay,
    customEditingMessage,
    setCustomEditingMessage,
    notifyOn,
    setNotifyOn,
    blockActions,
    setBlockActions,
    showReactions,
    setShowReactions,
    useReaction,
    addReaction,
    setReactions,
    reactions,
    allowReactions,
    setAllowReactions,
  };
};
